import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDeliveryDashboard,
  fetchDeliveryJobs,
  fetchDeliveryJob,
  advanceJob,
  assignJob,
  markDelivered,
  markComplete,
  cancelDeliveryJob,
  fetchDeliveryRoutes,
  saveDeliveryRouteThunk,
  deleteDeliveryRouteThunk,
  fetchDeliveryUsers,
  fetchActiveDeliverySession,
  arriveDeliveryRoutePoint,
  completeDeliveryRoutePoint,
  completeDeliveryRouteSession,
  updateDriverLocation,
  fetchDeliveryAreas,
  fetchDeliveryAssignments,
  fetchDeliveryRoutePoints,
  fetchMyDeliveryRoute,
} from "./deliveryThunks";

const initialState = {
  jobs: [],
  jobDetail: null,
  dashboard: null,

  routes: [],
  routePoints: [],
  routeAreas: [],
  routeAssignments: [],

  users: [],

  myRoute: null,

  execution: {
    assignment: null,    
    session: null,
    route: null,
    progress: null,
    points: [],
    driverLocation: null,
  },

  loading: false,
  jobsLoading: false,
  routesLoading: false,
  executionLoading: false,
  usersLoading: false,
  myRouteLoading: false,

  error: null,
};

const deliverySlice = createSlice({
  name: "delivery",
  initialState,
  reducers: {
    clearJobDetail: (state) => {
      state.jobDetail = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearExecution:(state)=>{

        state.execution={
            assignment:null,
            session:null,
            route:null,
            progress:null,
            points:[],
            driverLocation:null,
        }

    }
  },
  extraReducers: (builder) => {
    builder
      // fetchDeliveryDashboard
      .addCase(fetchDeliveryDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeliveryDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboard = action.payload;
      })
      .addCase(fetchDeliveryDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // fetchDeliveryJobs
      .addCase(fetchDeliveryJobs.pending, (state) => {
        state.jobsLoading = true;
        state.error = null;
      })
      .addCase(fetchDeliveryJobs.fulfilled, (state, action) => {
        state.jobsLoading = false;
        state.jobs = action.payload;
      })
      .addCase(fetchDeliveryJobs.rejected, (state, action) => {
        state.jobsLoading = false;
        state.error = action.payload;
      })

      // fetchDeliveryJob
      .addCase(fetchDeliveryJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeliveryJob.fulfilled, (state, action) => {
        state.loading = false;
        state.jobDetail = action.payload;
      })
      .addCase(fetchDeliveryJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // advanceJob
      .addCase(advanceJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(advanceJob.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(advanceJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // assignJob
      .addCase(assignJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(assignJob.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(assignJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // markDelivered
      .addCase(markDelivered.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(markDelivered.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(markDelivered.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // markComplete
      .addCase(markComplete.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(markComplete.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(markComplete.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // cancelDeliveryJob
      .addCase(cancelDeliveryJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(cancelDeliveryJob.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(cancelDeliveryJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // fetchDeliveryRoutes
      .addCase(fetchDeliveryRoutes.pending, (state) => {
        state.routesLoading = true;
        state.error = null;
      })
      .addCase(fetchDeliveryRoutes.fulfilled, (state, action) => {
        state.routesLoading = false;
        state.routes = action.payload;
      })
      .addCase(fetchDeliveryRoutes.rejected, (state, action) => {
        state.routesLoading = false;
        state.error = action.payload;
      })

      // saveDeliveryRouteThunk
      .addCase(saveDeliveryRouteThunk.pending, (state) => {
        state.routesLoading = true;
        state.error = null;
      })
      .addCase(saveDeliveryRouteThunk.fulfilled, (state) => {
        state.routesLoading = false;
      })
      .addCase(saveDeliveryRouteThunk.rejected, (state, action) => {
        state.routesLoading = false;
        state.error = action.payload;
      })

      // deleteDeliveryRouteThunk
      .addCase(deleteDeliveryRouteThunk.pending, (state) => {
        state.routesLoading = true;
        state.error = null;
      })
      .addCase(deleteDeliveryRouteThunk.fulfilled, (state) => {
        state.routesLoading = false;
      })
      .addCase(deleteDeliveryRouteThunk.rejected, (state, action) => {
        state.routesLoading = false;
        state.error = action.payload;
      })

      // fetchDeliveryUsers
      .addCase(fetchDeliveryUsers.pending, (state) => {
        state.usersLoading = true;
      })
      .addCase(fetchDeliveryUsers.fulfilled, (state, action) => {
        state.usersLoading = false;
        state.users = action.payload;
      })
      .addCase(fetchDeliveryUsers.rejected, (state) => {
        state.usersLoading = false;
      })
      // Delivery execution
      .addCase(fetchActiveDeliverySession.pending,(state)=>{
          state.executionLoading=true;
          state.error=null;
      })
      .addCase(fetchActiveDeliverySession.fulfilled, (state, action) => {
          state.executionLoading = false;
          state.execution.assignment = action.payload?.assignment || null;
          state.execution.session = action.payload?.session || null;
          state.execution.route = action.payload?.route || null;
          state.execution.progress = action.payload?.progress || null;
          state.execution.points = action.payload?.points || [];
      })
      .addCase(fetchActiveDeliverySession.rejected,(state,action)=>{
          state.executionLoading=false;
          state.error=action.payload;
      })
      
      .addCase(arriveDeliveryRoutePoint.pending,(state)=>{
          state.executionLoading=true;
      })
      .addCase(arriveDeliveryRoutePoint.fulfilled,(state)=>{
          state.executionLoading=false;
      })
      .addCase(arriveDeliveryRoutePoint.rejected,(state,action)=>{
          state.executionLoading=false;
          state.error=action.payload;
      })
      .addCase(completeDeliveryRoutePoint.pending,(state)=>{
          state.executionLoading=true;
      })
      .addCase(completeDeliveryRoutePoint.fulfilled,(state)=>{
          state.executionLoading=false;
      })
      .addCase(completeDeliveryRoutePoint.rejected,(state,action)=>{
          state.executionLoading=false;
          state.error=action.payload;
      })
      .addCase(completeDeliveryRouteSession.pending,(state)=>{
          state.executionLoading=true;
      })
      .addCase(completeDeliveryRouteSession.fulfilled,(state)=>{
          state.executionLoading=false;
          state.execution.session=null;
          // state.execution.progress=null;
          // state.execution.currentPoint=null;
          // state.execution.routePoints=[];
          // state.execution.visitLogs=[];
          state.execution.assignment=null;
          state.execution.route=null;
          state.execution.progress=null;
          state.execution.points=[];
          state.execution.driverLocation=null;
      })
      .addCase(completeDeliveryRouteSession.rejected,(state,action)=>{
          state.executionLoading=false;
          state.error=action.payload;
      })
      .addCase(updateDriverLocation.fulfilled,(state,action)=>{
          state.execution.driverLocation=action.payload;
      })
      .addCase(fetchDeliveryAreas.fulfilled,(state,action)=>{
        state.routeAreas = action.payload;
      })

      .addCase(fetchDeliveryRoutePoints.fulfilled,(state,action)=>{
          state.routePoints = action.payload;
      })

      .addCase(fetchDeliveryAssignments.fulfilled,(state,action)=>{
          state.routeAssignments = action.payload;
      })
      
      .addCase(fetchMyDeliveryRoute.pending, (state) => {
        state.myRouteLoading = true;
        state.error = null;
      })
      .addCase(fetchMyDeliveryRoute.fulfilled, (state, action) => {
        state.myRouteLoading = false;
        state.myRoute = action.payload;
      })
      .addCase(fetchMyDeliveryRoute.rejected, (state, action) => {
        state.myRouteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearJobDetail, clearError, clearExecution } = deliverySlice.actions;
export default deliverySlice.reducer;
